// extracted by mini-css-extract-plugin
export var bottom = "footer-module--bottom--b942b";
export var brand = "footer-module--brand--65b80";
export var brandLogo = "footer-module--brandLogo--3dac9";
export var contact = "footer-module--contact--7c331";
export var contactBrand = "footer-module--contactBrand--c1f61";
export var contactCta = "footer-module--contactCta--83b19";
export var contactCtaContent = "footer-module--contactCtaContent--300b2";
export var contactCtaText = "footer-module--contactCtaText--4d498";
export var contactLines = "footer-module--contactLines--f9e1f";
export var contactTitle = "footer-module--contactTitle--14040";
export var footer = "footer-module--footer--03d8a";
export var legal = "footer-module--legal--32f04";
export var legalLink = "footer-module--legalLink--634db";
export var links = "footer-module--links--62dc4";
export var linksCol = "footer-module--linksCol--179a0";
export var linksColLink = "footer-module--linksColLink--57479";
export var linksColList = "footer-module--linksColList--673fa";
export var linksColTitle = "footer-module--linksColTitle--58aa4";
export var social = "footer-module--social--5e80f";
export var socials = "footer-module--socials--d38f9";
export var top = "footer-module--top--7e0d9";
export var wrap = "footer-module--wrap--9f933";